import React, { useEffect, useState } from 'react';
import { FaTimes, FaExpand, FaCompress } from 'react-icons/fa';
import dayjs from 'dayjs';

const API_URL = '/api';

const RFQItemsViewModal = ({ open, onClose, rfqId }) => {
  const [rfq, setRfq] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isMaximized, setIsMaximized] = useState(false);

  useEffect(() => {
    if (open && rfqId) {
      setLoading(true);
      fetch(`${API_URL}/rfqs/${rfqId}`)
        .then(res => res.json())
        .then(data => setRfq(data))
        .catch(() => setRfq(null))
        .finally(() => setLoading(false));
    }
  }, [open, rfqId]);

  if (!open) return null;
const getItemRowClasses = (status, idx) => {
  // base zebra striping
  let base = idx % 2 === 0 ? 'bg-gray-50' : 'bg-white';

  switch (status) {
    case 'Win':
      return 'bg-green-100 text-green-900';

    case 'Bid Closed':
      return 'bg-red-100 text-red-900';

    case 'Negotiation':
      return 'bg-amber-100 text-amber-900';

    case 'Bid Submitted':
      return 'bg-blue-100 text-blue-900';

    case 'Open':
    default:
      return base;
  }
};
const getItemStatusChip = (status) => {
  switch (status) {
    case 'Win':
      return 'bg-green-600 text-white';

    case 'Bid Closed':
      return 'bg-red-600 text-white';

    case 'Negotiation':
      return 'bg-amber-500 text-white';

    case 'Bid Submitted':
      return 'bg-blue-600 text-white';

    case 'Open':
      return 'bg-slate-500 text-white';

    default:
      return 'bg-gray-500 text-white';
  }
};

  return (
    <div
      className={`fixed inset-0 z-50 bg-black bg-opacity-40
        ${isMaximized ? '' : 'flex items-center justify-center'}
      `}
    >
      <div
        className={`bg-[#E5E1DA] shadow-2xl relative overflow-y-auto transition-all duration-300
          ${isMaximized
            ? 'w-full h-full rounded-none'
            : 'w-full max-w-6xl max-h-[90vh] rounded-2xl mx-2'
          }
          p-4 sm:p-6
        `}
      >
        {/* Top Right Icons */}
        <div className="absolute top-3 right-3 flex gap-2">
          <button
            onClick={() => setIsMaximized(p => !p)}
            className="text-[#2b6777] hover:text-[#52ab98]"
          >
            {isMaximized ? <FaCompress /> : <FaExpand />}
          </button>
          <button
            onClick={onClose}
            className="text-[#2b6777] hover:text-red-500"
          >
            <FaTimes />
          </button>
        </div>

        {/* Title */}
        <h2 className="text-xl md:text-2xl font-bold text-[#2b6777] mb-6 text-center">
          RFQ Details
        </h2>

        {loading ? (
          <div className="text-center">Loading...</div>
        ) : rfq ? (
          <>
            {/* RFQ Information */}
            <div className="bg-white rounded-xl p-5 mb-6">
              <h3 className="text-lg font-semibold text-[#2b6777] mb-4">
                RFQ Information
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 text-sm">
                {[
                  ['RFQ No', rfq.rfq_no],
                  ['RFQ Date', rfq.rfq_date ? dayjs(rfq.rfq_date).format('DD-MM-YYYY') : '-'],
                  ['PR No', rfq.pr_no || '-'],
                  ['Valid Upto', rfq.valid_upto ? dayjs(rfq.valid_upto).format('DD-MM-YYYY') : '-'], 
                  ['Vendor Code', rfq.vendor_code],
                  ['Vendor Name', rfq.vendor_name],
                  ['Status', rfq.status],
                  // ['Delivery Terms', rfq.delivery_terms || '-'],
                  // ['Payment Terms', rfq.payment_terms || '-'],
                  ['Remarks', rfq.remark || '-'],
                  ['Created At', rfq.created_at ? dayjs(rfq.created_at).format('DD-MM-YYYY HH:mm') : '-'],
                  ['Updated At', rfq.updated_at ? dayjs(rfq.updated_at).format('DD-MM-YYYY HH:mm') : '-']
                ].map(([label, value]) => (
                  <div key={label}>
                    <span className="font-medium text-gray-600">{label}:</span>
                    <div className="text-gray-800">{value}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* RFQ Items */}
            <div className="bg-white rounded-xl p-5">
              <h3 className="text-lg font-semibold text-[#2b6777] mb-4">
                RFQ Items
              </h3>

              <div className="overflow-x-auto max-h-[60vh] border rounded-lg">
                <table className="min-w-full border-collapse text-sm">
                  <thead className="sticky top-0 bg-[#c8d8e4] text-[#2b6777]">
                    <tr>
                      <th className="p-3 text-center w-12">#</th>
                      <th className="p-3 text-left">Item Code</th>
                      <th className="p-3 text-left">Description</th>
                      <th className="p-3 text-right">Qty</th>
                      <th className="p-3 text-center">UOM</th>
                      <th className="p-3 text-right">Unit Price</th>
                      <th className="p-3 text-right">Amount</th>
                      <th className="p-3 text-right">Disc %</th>
                      <th className="p-3 text-right">Discount</th>
                      <th className="p-3 text-right">Net Amount</th>
                      <th className="p-3 text-center">Status</th>
                      <th className="p-3 text-center">Remarks</th>
                      <th className="p-3 text-center">Valid Upto</th>
                    </tr>
                  </thead>

                  <tbody>
                    {rfq.items?.length ? rfq.items.map((item, idx) => {
                      
                      return (
                        <tr
  key={idx}
  className={`border-b transition-colors ${getItemRowClasses(item.status, idx)}`}
>

                          <td className="p-3 text-center">{idx + 1}</td>
                          <td className="p-3">{item.item_code}</td>
                          <td className="p-3">{item.description}</td>
                          <td className="p-3 text-right">{item.quantity}</td>
                          <td className="p-3 text-center">{item.unit_of_measure}</td>
                          <td className="p-3 text-right">{item.unit_price}</td>
                          <td className="p-3 text-right">{item.amount}</td>
                          <td className="p-3 text-right">{item.discount_percent}</td>
                          <td className="p-3 text-right">{item.discount}</td>
                          <td className="p-3 text-right font-semibold">{item.net_amount}</td>
<td className="p-3 text-center">
  <span
    className={`inline-flex px-3 py-1 rounded-full text-xs font-semibold
    ${getItemStatusChip(item.status)}`}
  >
    {item.status}
  </span>
</td>
<td className="p-3 text-center">{item.remarks}</td>
<td className="p-3 text-center">
  {rfq.valid_upto ? dayjs(rfq.valid_upto).format('DD-MM-YYYY') : '-'}
</td>
                        </tr>

                      );
                    }) : (
                      <tr>
                        <td colSpan="12" className="p-4 text-center text-gray-500">
                          No items found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Footer */}
            <div className="mt-6 flex justify-end">
              <button
                onClick={onClose}
                className="px-4 py-2 rounded bg-[#52ab98] hover:bg-[#2b6777] text-white font-semibold"
              >
                Close
              </button>
            </div>
          </>
        ) : (
          <div className="text-center text-red-500">RFQ not found</div>
        )}
      </div>
    </div>
  );
};

export default RFQItemsViewModal;
